import type { Site } from "@/mocks/sites";

type Props = {
  site: Site;
  size?: number;
  className?: string;
};

export default function SiteLogo({ site, size = 48, className = "" }: Props) {
  return (
    <span
      className={`flex shrink-0 items-center justify-center rounded-lg ${className}`}
      style={{
        width: size,
        height: size,
        backgroundColor: `${site.color}1a`,
        color: site.color,
      }}
    >
      <i className={site.icon} style={{ fontSize: Math.round(size * 0.5) }}></i>
    </span>
  );
}